module.exports = __webpack_public_path__ + "img/news-list-ukr-2.bd4c6840.png";